export default __webpack_public_path__ + "static/citroenist-2d890b0a3095aee870875d0907703077.webp";